"use client";

import { Typography } from "@/components/ui/typography";
import { cn } from "@/lib/utils";
import { memo } from "react";
import { IndustryPricingPlansProps } from "./types";
import { PricingCard } from "@/components/screen/global-components/pricing";
import { industryPricingPlansCards } from "./constants";

const IndustryPricingPlans = ({
  className,
  ...rest
}: IndustryPricingPlansProps) => {
  return (
    <section
      className={cn(
        "section bg-background-secondary",
        className
      )}
      {...rest}
    >
      <div className="container mx-auto">
        <div className="grid grid-cols-1 place-content-start py-12 gap-6 lg:gap-12 lg:py-20">
          <div className="grid grid-cols-1 text-center place-content-start gap-4 lg:gap-2 w-full max-w-[800] mx-auto">
            <Typography
              variant="heading4"
              className="text-semantic-text-primary lg:text-[#1b1f3b] lg:text-[54px]/20 lg:font-medium lg:leading-[135%] w-full max-w-[620] mx-auto"
            >
              <h1>Our translation pricing</h1>
            </Typography>
            <Typography
              variant="subHeadingSm"
              className="text-gray-500 lg:gray-600 lg:text-xl lg:leading-[150%] lg:font-normal"
              asChild
            >
              <p>
                We translation plans across 100+ languages. Each plan will pair
                your project with a translator qualified with specialized
                experience translating for the energy industry.
              </p>
            </Typography>
          </div>
          {/* 2026-05-25 — added lg:bg-white so the joined Standard
              + Certified wrapper picks up the solid white surface
              that the PricingCard now uses at every breakpoint
              (was transparent before, blending into page bg). */}
          <div
            className="mt-6 lg:mt-12 grid grid-cols-1 gap-4 md:grid-cols-2 lg:flex lg:flex-wrap md:col-span-2 lg:rounded-2xl lg:border lg:border-[#C8D4F3] lg:bg-white lg:grid lg:grid-cols-2 lg:gap-0 lg:mx-auto lg:w-full lg:max-w-[692]"
          >
            {industryPricingPlansCards.map((card, i) => {
              return (
                <PricingCard
                  key={i}
                  {...card}
                  className={cn(
                    {
                      "lg:border-0 lg:border-r-1 lg:rounded-none lg:rounded-tl-2xl lg:rounded-bl-2xl":
                        i === 0,
                    },
                    {
                      "lg:border-0 lg:rounded-none lg:rounded-tr-2xl lg:rounded-br-2xl":
                        i === 1,
                    }
                  )}
                />
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default memo(IndustryPricingPlans);
